(function ($, Drupal) {

  // Background image swap function via data attribute
  Drupal.behaviors.initDataSwap = {
    attach: function (context, settings) {

      $('.lifestyle', context).once('initDataSwap').each(function (index, item) {

        let $el = $(this);

        if ($el.hasClass('below')) {

          let $data = $el.find('.lifestyle__data'),
            $img = $el.find('.lifestyle__figure');

          $img.after($data);
        }

      });

    }
  };

})(jQuery, Drupal);
